import React, { forwardRef } from 'react';
import cn from 'classnames';
import OrderHeader from './OrderHeader';
import ProductHeader from './ProductHeader';
import CandyCartHeader from './CandyCartHeader';
import { REGISTERED_APPS } from '../../shared/types/Apps';

interface Props {
  hidden: boolean;
  currentApp: REGISTERED_APPS;
}

const UpsellHeader = forwardRef<HTMLDivElement, Props>(
  ({ hidden, currentApp }, ref) => {
    const getCurrentAppHeader = {
      [REGISTERED_APPS.LAST_UPSELL]: <OrderHeader />,
      [REGISTERED_APPS.CANDYRACK]: <ProductHeader />,
      [REGISTERED_APPS.CANDYCART]: <CandyCartHeader />,
      [REGISTERED_APPS.PRODUCT_PAGE_PLACEMENT]: <></>,
    };

    return (
      <div className={cn(hidden && 'hidden')} ref={ref}>
        <div
          className={cn(
            'Product-Line flex p-15 items-center md:px-25 relative z-10 bg-primary-5',
            currentApp === REGISTERED_APPS.CANDYCART &&
              'justify-between -mb-10',
          )}
        >
          {getCurrentAppHeader[currentApp]}
        </div>
      </div>
    );
  },
);

export default UpsellHeader;
